module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/PostingIconHover.5d4917ea.svg";